//MATERIAL
export const CHEVRON_LEFT = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="#1976D2">
<path d="M28.05 36 16 23.95 28.05 11.9l2.15 2.15-9.9 9.9 9.9 9.9Z"/>
</svg>
`;
export const DOWNLOAD = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="#1976D2">
<path d="M11 40q-1.2 0-2.1-.9Q8 38.2 8 37v-7.15h3V37h26v-7.15h3V37q0 1.2-.9 2.1-.9.9-2.1.9Zm13-7.65-9.65-9.65 2.15-2.15 6 6V8h3v18.55l6-6 2.15 2.15Z"/>
</svg>
`;
export const EDIT = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="#1976D2">
<path d="M9 39h2.2l22.15-22.15-2.2-2.2L9 36.8Zm30.7-24.3-6.4-6.4 2.1-2.1q.85-.85 2.1-.85t2.1.85l2.2 2.2q.85.85.85 2.1t-.85 2.1Zm-2.1 2.1L12.4 42H6v-6.4l25.2-25.2Zm-5.35-1.05-1.1-1.1 2.2 2.2Z"/>
</svg>
`;

// LANDING

export const EVENT_LANDING = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="#1976D2">
<path d="M38.65 14.2q.7 0 1.15-.5.45-.5.45-1.1 0-.7-.45-1.15-.45-.45-1.15-.45t-1.15.45q-.45.45-.45 1.15 0 .6.45 1.1.45.5 1.15.5Zm-8.6
	0q.7 0 1.15-.5.45-.5.45-1.1 0-.7-.45-1.15-.45-.45-1.15-.45t-1.15.45q-.45.45-.45 1.15 0 .6.45 1.1.45.5 1.15.5Zm-1.1 7.3h10.7q
	0-1.65-1.65-2.575Q36.35 18 34.3 18q-2.05 0-3.7.925-1.65.925-1.65 2.575ZM13.7 43.95q-4.85 0-8.275-3.5Q2 36.95 2 32.25V18.9h23.4v13.35q
	0 4.7-3.4 8.2-3.4 3.5-8.3 3.5Zm0-3q3.6 0 6.15-2.625Q22.4 35.7 22.4 32.25V21.9H5v10.35q0 3.45 2.55 6.075t6.15 2.625Zm20.6-11.9q-1.7
	0-3.3-.425-1.6-.425-3.05-1.225v-3.35q1.3.75 2.925 1.375 1.625.625 3.425.625 3.6 0 6.15-2.4Q43 21.25 43 17.8V7H25.45v9.45h-3V4H46v13.8q
	0 4.65-3.4 7.95t-8.3 3.3ZM9.45 28.7q.7 0 1.15-.45.45-.45.45-1.15t-.45-1.15q-.45-.45-1.15-.45t-1.15.45q-.45.45-.45 1.15t.45 1.15q.45.45
	1.15.45Zm8.65 0q.7 0 1.15-.45.45-.45.45-1.15t-.45-1.15q-.45-.45-1.15-.45t-1.15.45q-.45.45-.45 1.15t.45 1.15q.45.45 1.15.45Zm-4.25 7.75q
	2.05 0 3.7-.925 1.65-.925 1.65-2.575H8.5q0 1.65 1.65 2.575 1.65.925 3.7.925Zm-.1-5.25Zm20.5-14.45Z"/>
</svg>
`;

export const RESERVATION_LANDING = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="#1976D2">
<path d="M18 32q-.85 0-1.425-.575Q16 30.85 16 30v-4q.85 0 1.425-.575Q18 24.85 18 24q0-.85-.575-1.425Q16.85 22 16 22v-4q
	0-.85.575-1.425Q17.15 16 18 16h12q.85 0 1.425.575Q32 17.15 32 18v4q-.85 0-1.425.575Q30 23.15 30 24q0 .85.575 1.425Q
	31.15 26 32 26v4q0 .85-.575 1.425Q30.85 32 30 32Zm6-3q.4 0 .7-.3.3-.3.3-.7 0-.4-.3-.7-.3-.3-.7-.3-.4 0-.7.3-.3.3-.3.7
	0 .4.3.7.3.3.7.3Zm0-4q.4 0 .7-.3.3-.3.3-.7 0-.4-.3-.7-.3-.3-.7-.3-.4 0-.7.3-.3.3-.3.7 0 .4.3.7.3.3.7.3Zm0-4q.4
	0 .7-.3.3-.3.3-.7 0-.4-.3-.7-.3-.3-.7-.3-.4 0-.7.3-.3.3-.3.7 0 .4.3.7.3.3.7.3ZM13 46q-1.2 0-2.1-.9-.9-.9-.9-2.1V5q
	0-1.2.9-2.1.9-.9 2.1-.9h22q1.2 0 2.1.9.9.9.9 2.1v38q0 1.2-.9 2.1-.9.9-2.1.9Zm0-4.5V43h22v-1.5Zm0-3h22v-29H13Zm0-32h22V5H13Zm0 0V5v1.5Zm0 35V43Z"/>
</svg>
`;

export const NOT_ALLOWED = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#C31111">
	<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9
	1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/>
</svg>
`;